import React, { Fragment } from "react";
import API from "@unisearch/helpers/api";
import dynamic from "next/dynamic";

import {
  StudyBannerTwo,
  StudyBanner,
  StudyVideo,
  StudyLinks,
  StudyWhyCountryIntro,
} from "@modules/study/country/study_why_country";
import { LayoutMain } from "@unisearch/theme/layout";

const BlogUpdate = dynamic(() => import("@modules/study/home/blog_update"), {
  ssr: false,
});
const ScrollPopup = dynamic(() => import("@unisearch/common/scroll_popup"), {
  ssr: false,
});

const CountryPage = ({
  pageData,
  country_name,
  country_page_slug,
  countryData,
}) => {
  return (
    <Fragment>
      <LayoutMain
        isLeadPopup={true}
        footer_with_evaluation
        title={pageData?.pageTitle}
        metaTitle={pageData?.metaTitle || pageData?.pageTitle}
        metaKeywords={pageData?.metaKeyword || "unisearch, study"}
        metaDescription={pageData?.metaDescription}
        metaImage={pageData?.featureImage?.src}
        metaUrl={`${process.env.NEXT_PUBLIC_URL}/study/${country_name}/${country_page_slug}`}
      >
        {pageData && pageData?.videoType ? (
          <StudyBannerTwo
            pageData={pageData}
            name={country_name}
            linkType="study"
          />
        ) : (
          <StudyBanner
            pageData={pageData}
            name={country_name}
            linkType="study"
          />
        )}
        {(pageData?.videoupload !== null || pageData?.embedCode !== "") && (
          <StudyVideo countryData={countryData} pageData={pageData} />
        )}
        <StudyLinks linkType="study" name={country_name} pageData={pageData} />
        <StudyWhyCountryIntro
          linkType="study"
          name={country_name}
          pageData={pageData}
        />
        <BlogUpdate />
      </LayoutMain>
      {/* <ScrollPopup /> */}
    </Fragment>
  );
};

export default CountryPage;

export async function getServerSideProps({ params }) {
  const { country_name, country_page_slug } = params;

  let props = {
    pageData: {},
    country_name,
    country_page_slug,
  };

  try {
    const resp = await API.get(
      `/public/page?pageType=country&slug=${country_page_slug}&referenceSlug=${country_name}`
    );
    if (!resp.error && resp.data) {
      props.pageData = resp.data;
    } else {
      return {
        redirect: {
          permanent: false,
          destination: "/404",
        },
      };
    }
    return {
      props,
    };
  } catch (err) {
    return {
      props,
    };
  }
}
